module.exports = __webpack_public_path__ + "static/img/3.8124a24.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/zh/3.png
// module id = jwdZ
// module chunks = 0